<template>
  <div style="clear: both;">
    <b-row>
      <b-col xs="12" style="font-weight: bold; text-transform: capitalize;">
        <a id="need-help" href="#" v-b-toggle.contact>{{ $t('ml_107034') }}</a>
      </b-col>
    </b-row>

    <b-collapse id="contact">
      <b-card>
        <div class="card-text" style="font-size: 14px;">
          <div v-for="(number, idx) in numbers" :key="idx">
            <div v-if="number.stringId" style="color: #999; text-decoration: underline;">{{ $t(number.stringId) }}</div>
            <div v-html="number.content"></div>
          </div>
        </div>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  props: {
    numbers: {
      type: Array,
      default: () => []
    }
  }
}
</script>
